import React, {createElement, Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import autoprefixer from 'material-ui/utils/autoprefixer';
import CircularProgress from 'material-ui/CircularProgress';
import withWidth from 'material-ui/utils/withWidth';
import compose from 'recompose/compose';
import AdminRoutes from 'admin-on-rest/lib/AdminRoutes';
import FuseAppBar from './FuseAppBar';
import Sidebar from './Sidebar';
import Menu from 'admin-on-rest/lib/mui/layout/Menu';
import Notification from 'admin-on-rest/lib/mui/layout/Notification';
import defaultTheme from 'admin-on-rest/lib/mui/defaultTheme';
import {setSidebarVisibility as setSidebarVisibilityAction} from 'admin-on-rest/lib/actions';

import {FuseFooter} from '../global/footer';
import FuseTheme from '../global/theme';

const styles = {
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
    },
    main: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
    },
    bodyContainer: {
        display: 'flex',
        alignItems: 'flex-start',
        flexFlow: 'row wrap',
        overflow: 'auto',
        width: '100%'
    },
    body: {
        backgroundColor: FuseTheme.palette.contentCanvasColor,
        display: 'flex',
        flex: 1,
        overflow: 'hidden',
    },
    bodySmall: {
        backgroundColor: FuseTheme.palette.canvasColor,
    },
    content: {
        flex: '1 1 100%',
        padding: '2em',
    },
    contentSmall: {
        flex: 1,
        paddingTop: '3em',
    },
    loader: {
        position: 'absolute',
        top: 0,
        right: 0,
        margin: 16,
        zIndex: 1200,
    },
};

const prefixedStyles = {};

class FuseLayout extends Component {
    componentWillMount() {
        if (this.props.width !== 1) {
            this.props.setSidebarVisibility(true);
        }
    }

    render() {
        const {
            children,
            customRoutes,
            dashboard,
            footer,
            isLoading,
            logout,
            menu,
            open,
            catchAll,
            theme,
            title,
            width,
        } = this.props;

        const muiTheme = getMuiTheme(theme);
        if (!prefixedStyles.main) {
            const prefix = autoprefixer(muiTheme);
            prefixedStyles.wrapper = prefix(styles.wrapper);
            prefixedStyles.main = prefix(styles.main);
            prefixedStyles.body = prefix(styles.body);
            prefixedStyles.bodySmall = prefix(styles.bodySmall);
            prefixedStyles.content = prefix(styles.content);
            prefixedStyles.contentSmall = prefix(styles.contentSmall);
        }
        const sidebarClass = (open) ? ' sidebar-open' : '';

        return (
            <MuiThemeProvider muiTheme={muiTheme}>
                <div style={prefixedStyles.wrapper} className="wrapper">
                    <div style={prefixedStyles.main} className="wrapper-inner">
                        {width !== 1 && <FuseAppBar title={title}/>}
                        <div
                            className="body"
                            style={
                                width === 1 ? (
                                    prefixedStyles.bodySmall
                                ) : (
                                    prefixedStyles.body
                                )
                            }
                        >
                            <div style={styles.bodyContainer} className={`body-content${sidebarClass}`}>
                                <div
                                    style={
                                        width === 1 ? (
                                            prefixedStyles.contentSmall
                                        ) : (
                                            prefixedStyles.content
                                        )
                                    }
                                >
                                    <AdminRoutes
                                        customRoutes={customRoutes}
                                        dashboard={dashboard}
                                        catchAll={catchAll}
                                    >
                                        {children}
                                    </AdminRoutes>
                                    {/*{createElement(footer || FuseFooter)}*/}
                                </div>
                                {createElement(footer || FuseFooter)}
                            </div>
                            <Sidebar theme={theme}>
                                {createElement(menu || Menu, {
                                    logout,
                                    hasDashboard: !!dashboard,
                                })}
                            </Sidebar>
                        </div>
                        <Notification/>
                        {isLoading && (
                            <CircularProgress
                                className="app-loader"
                                color="#fff"
                                size={width === 1 ? 20 : 30}
                                thickness={2}
                                style={styles.loader}
                            />
                        )}
                    </div>
                </div>
            </MuiThemeProvider>
        );
    }
}

const componentPropType = PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.string,
]);

FuseLayout.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    catchAll: componentPropType,
    customRoutes: PropTypes.array,
    dashboard: componentPropType,
    footer: componentPropType,
    isLoading: PropTypes.bool.isRequired,
    logout: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.func,
        PropTypes.string,
    ]),
    menu: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    setSidebarVisibility: PropTypes.func.isRequired,
    title: PropTypes.node.isRequired,
    theme: PropTypes.object.isRequired,
    width: PropTypes.number,
};

FuseLayout.defaultProps = {
    theme: defaultTheme,
};

function mapStateToProps(state) {
    return {
        isLoading: state.admin.loading > 0,
        open: state.admin.ui.sidebarOpen,
    };
}

const enhance = compose(
    connect(mapStateToProps, {
        setSidebarVisibility: setSidebarVisibilityAction,
    }),
    withWidth()
);

export default enhance(FuseLayout);



// WEBPACK FOOTER //
// ./src/Fuse/admin/FuseLayout.js